import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import AddressAutoCompleteInput from 'bento-ordering/base/components/AddressAutoCompleteInput';

import HeroSecondaryCta from 'bento-ordering/base/components/HeroSecondaryCta';
import HeroHeading from 'bento-ordering/base/ui_components/HeroHeading';
import { scrollTo } from 'bento-ordering/base/utils/domHelpers';

const LocationListHeroContent = ({
  heading,
  handleSelect,
  address,
  showAddressAutoComplete
}) => {
  const baseSecondaryCtaText = 'browse locations below';
  const secondaryCtaText = `${
    showAddressAutoComplete ? 'or' : ''
  } ${baseSecondaryCtaText}`;

  return (
    <Box width="100%">
      <HeroHeading>{heading}</HeroHeading>
      {showAddressAutoComplete && (
        <Box
          minHeight="53px"
          mt={2}
          ml="auto"
          mr="auto"
          maxWidth={'430px'}
          pr={{ xs: 3, md: 0 }}
          pl={{ xs: 3, md: 0 }}
        >
          <AddressAutoCompleteInput
            label="Start with your address"
            includeAdornment
            handleSelect={handleSelect}
            isOnDarkBackground
            initialValue={address}
          />
        </Box>
      )}
      <Box mt={1.5}>
        <HeroSecondaryCta
          handleClick={() =>
            scrollTo(document.getElementById('locations-list-container'))
          }
          label={secondaryCtaText}
        />
      </Box>
    </Box>
  );
};

LocationListHeroContent.propTypes = {
  heading: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  address: PropTypes.string,
  showAddressAutoComplete: PropTypes.bool
};

LocationListHeroContent.defaultProps = {
  address: '',
  showAddressAutoComplete: true
};

export default LocationListHeroContent;
